import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ReactHtmlParser from "react-html-parser";
import useCMS from "../hooks/useCMS";

function InfoBox({ heading, children, register, name, label, error }) {
	const { translations } = useCMS();
	const inputClass = classnames("styled-checkbox", { "is-danger": !!error });

	return (
		<div className="box info-box has-background-white">
			<h3>{heading}</h3>
			<hr />
			{ReactHtmlParser(children)}
			<p style={{ marginTop: "2em" }}>
				<label htmlFor={name}>
					<input
					name={name}
					id={name}
					type="checkbox"
					className={inputClass}
					ref={register({
						required: {
							value: true,
							message: translations.thefieldismandatory
						}
					})}
				/>
				{label}</label>
			</p>
			{error && <p className={"help is-primary"}>{error.message}</p>}
		</div>
	);
}

InfoBox.defaultProps = {
	error: null
};

InfoBox.propTypes = {
	heading: PropTypes.string.isRequired,
	children: PropTypes.string.isRequired,
	register: PropTypes.func.isRequired,
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	error: PropTypes.shape({ message: PropTypes.string })
};

export default InfoBox;